import { SaleBanner } from '@wix/app-market-components';
import React, { useEffect } from 'react';
import { useManageAppsBi } from '../../useManageAppsBi';
import { useExperiments } from '@wix/wix-experiments-react';
export const AppMarketSaleBanner = ({ goToHomePage, msid, origin, i18n, }) => {
    const { experiments } = useExperiments();
    const isWixSaleEnabled = experiments.enabled('specs.app-market.Sale');
    const { appMarketSaleBannerBI } = useManageAppsBi();
    useEffect(() => {
        if (isWixSaleEnabled) {
            appMarketSaleBannerBI({ msid, origin, actionType: 'impression' });
        }
    }, [origin, msid, isWixSaleEnabled, appMarketSaleBannerBI]);
    return (isWixSaleEnabled && (React.createElement(SaleBanner, { i18n: i18n, layout: 'narrow', onClick: () => {
            appMarketSaleBannerBI({ msid, origin, actionType: 'click' });
            goToHomePage();
        } })));
};
//# sourceMappingURL=app-market-sale-banner.js.map